import { FaRegSadTear } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import Search from "./Search";
import { useEffect, useState } from "react";
import useFetch from "../Components/FetchHook";
import ReactLoading from 'react-loading';
import React from 'react';



import { Helmet } from "react-helmet";


const Households = () => {
  const navigate = useNavigate(); // Initialize the useNavigate hook
  const handleItemClick = (pid) => {
    const uniqueId = `${pid}-${uuidv4()}`; // Concatenate pid and UUID
    navigate(`/desc/${uniqueId}`); // Navigate to the Description page with the selected object ID
  };

  const { data, pending, error } = useFetch("https://campus-closet-server.vercel.app/items/products");

  const [searchResults, setSearchResults] = useState([]);
  const [filteredHouseholds, setFilteredHouseholds] = useState([]);

  useEffect(() => {
    if (data) {
      // Filter the data for HouseHolds category
      const filteredData = data.filter(
        (item) => item.product_category === "HouseHolds"
      );
      setFilteredHouseholds(filteredData);
      setSearchResults(filteredData);
    }
  }, [data]);

 
  

  return (
    <section>
  
      {data && (
        <Search searchData={filteredHouseholds} setSearchResults={setSearchResults} />
      )}
      <div className="mx-5 md:mx-32  min-h-screen">
        
        {/* Condition for pending state */}
        {pending ? (
          <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
            <div>Loading...
              <ReactLoading type="spinningBubbles" color="#444654" height={'80px'} width={'80px'} />
            </div>
          </div>
        ) : error ? (
          // Condition for error state
          <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
            <p>Failed to fetch HouseHolds products 😢</p>
          </div>
        ) : (
          <>
            {/* Rendering HouseHolds products */}
            <h2 className="text-center text-xl mt-5 font-bold my-3">HouseHolds</h2>

            {/* Condition for no search results */}
            {searchResults.length === 0 ? (
              <div className="text-center">
                <FaRegSadTear className="text-6xl m-auto text-gray-400 mb-5" />
                <h2 className="text-2xl mb-5">
                  No HouseHolds products found.
                </h2>
              </div>
            ) : (
              <div className="flex flex-wrap  justify-center gap-4 mb-4">
                {/* Render each HouseHolds product */}
                {searchResults.map((item, index) => (
                  <div
                    key={index}
                    className="shadow-2xl h-60 w-60 hover:scale-105 rounded-md bg-white flex flex-col cursor-pointer"
                    style={{ transition: "transform 0.3s ease-in-out" }}
                    onClick={() => handleItemClick(item.pid)}
                  >
                    {/* Render the product image */}
                    {item.image ? (
                      <div className="h-48">
                        <img
                          className="h-full w-full object-contain rounded-md"
                          src={item.image.replace("/v", "/q_35/v")}
                          alt={item.product_name}
                        />
                      </div>
                    ) : (
                      // Render placeholder icon if no image available
                      <div className="flex items-center justify-center h-3/4 rounded-md bg-gray-100">
                        <FaRegSadTear className="text-4xl text-gray-500" />
                      </div>
                    )}
                    {/* Render product information */}
                    <div className="ml-2">
                      <p>{item.product_name}</p>
                      <p>KSh {item.price}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Households;
